import { render, staticRenderFns } from "./ModalNewFeatures.vue?vue&type=template&id=728aec40&scoped=true&"
import script from "./ModalNewFeatures.vue?vue&type=script&lang=js&"
export * from "./ModalNewFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewFeatures.vue?vue&type=style&index=0&id=728aec40&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728aec40",
  null
  
)

export default component.exports